/*
    Видео с ютуба/вимео на странице
*/

let video_wrap = $('.js-video-wrap');

if (video_wrap.length) {
    let _img_template = '//img.youtube.com/vi/#/sddefault.jpg';

    video_wrap.each((index, el) => {
        let _self = $(el);
        let _iframe = _self.find('iframe');
        let _url = _iframe.attr('src');
        let _preview_pics = _url.split('/');
        let _preview_pic_url;

        _iframe.wrap('<div class="video-wrap" />');

        if (_self.data('preview')) {
            _preview_pic_url = _self.data('preview');
        } else {
            _preview_pic_url = _preview_pics[_preview_pics.length - 1];
            _preview_pic_url = _img_template.replace('#', _preview_pic_url.split('?')[0]);
        }


        _self.find('.video-wrap').append(`<div class="video-wrap__play js-video-wrap-play" style="background-image: url('${_preview_pic_url}')"></div>`);

        _self.find('.js-video-wrap-play').on('click', (e) => {
            e.preventDefault();
            _self.addClass('_play');

            if (_url.indexOf('?') > 0) {
                _self.find('iframe').attr('src', _url + '&' + 'autoplay=1');
            } else {
                _self.find('iframe').attr('src', _url + '?' + 'autoplay=1');
            }
        });
    });
}


// WEBPACK FOOTER //
// ./_src/js/modules/YoutubeVideo.js